import styled from "styled-components";
import { Add, Remove } from "@material-ui/icons";

const Counter = ({
  value,
  maxValue,
  minValue,
  clickCallback,
  disabled,
}: {
  value: number;
  maxValue: number;
  minValue: number;
  clickCallback: (v: number) => void;
  disabled?: boolean;
}) => {
  return (
    <Root $disabled={disabled}>
      <RightBorder>
        <ButtonWrapper
          onClick={e => {
            e.stopPropagation();
            if (disabled) return;
            if (value > minValue) {
              clickCallback(value - 1);
            }
          }}
        >
          <Remove />
        </ButtonWrapper>
      </RightBorder>
      <Text $disabled={disabled}>{`${value}/${maxValue}`} </Text>
      <LeftBorder>
        <ButtonWrapper
          onClick={e => {
            e.stopPropagation();
            if (disabled) return;
            if (value < maxValue) {
              clickCallback(value + 1);
            }
          }}
        >
          <Add />
        </ButtonWrapper>
      </LeftBorder>
    </Root>
  );
};

const ButtonWrapper = styled.button`
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  outline: none;
  padding: 0;
  border: 0;
  &:disabled {
    opacity: 0.4;
    cursor: default;
  }

  border-radius: 4px;
`;

const Text = styled.div<{ $disabled?: boolean }>`
  padding: 0px 8px;
  flex-grow: 1;
  text-align: center;
  opacity: ${({ $disabled }) => ($disabled ? 0.8 : 1)};
`;

const LeftBorder = styled.div`
  border-left: 1px solid ${props => props.theme.colors.concrete};
`;

const RightBorder = styled.div`
  border-right: 1px solid ${props => props.theme.colors.concrete};
`;

const Root = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  border: 1px solid ${({ theme, $disabled }) => ($disabled ? theme.colors.silver : theme.colors.concrete)};
  border-radius: 4px;
  opacity: ${({ $disabled }) => ($disabled ? 0.4 : 1)};
  pointer-events: ${({ $disabled }) => ($disabled ? "none" : "auto")};
`;

export default Counter;
